import React from 'react';
import { motion } from 'framer-motion';
export type CallSentiment = 'positive' | 'neutral' | 'negative';
interface SentimentIndicatorProps {
  sentiment: CallSentiment;
  isLight: boolean;
}
const ORDER: CallSentiment[] = ['negative', 'neutral', 'positive'];
const LABEL: Record<CallSentiment, string> = {
  positive: 'Positive',
  neutral: 'Neutral',
  negative: 'Negative'
};

/**
 * Caller sentiment as a quiet stat: a three-step meter (negative → neutral →
 * positive) with only the detected step lit, plus the label in the same tone.
 */
export function SentimentIndicator({
  sentiment,
  isLight
}: SentimentIndicatorProps) {
  const tone = {
    positive: {
      fill: 'bg-vexu',
      text: isLight ? 'text-vexu-700' : 'text-vexu'
    },
    neutral: {
      fill: isLight ? 'bg-slate-500' : 'bg-zinc-300',
      text: isLight ? 'text-slate-700' : 'text-zinc-200'
    },
    negative: {
      fill: 'bg-rose-500',
      text: isLight ? 'text-rose-600' : 'text-rose-400'
    }
  }[sentiment];
  const idle = isLight ? 'bg-slate-200' : 'bg-white/10';
  return <div className="flex items-center gap-2" aria-label={`Caller sentiment: ${LABEL[sentiment]}`} data-id="element-414" data-mp="rdjm6giugyuw">
      <div className="flex items-end gap-[3px]" aria-hidden="true" data-id="element-415" data-mp="cgslm3xfph3p">
        {ORDER.map((step, i) => <motion.span key={step} initial={{
        scaleY: 0.4,
        opacity: 0
      }} animate={{
        scaleY: 1,
        opacity: 1
      }} transition={{
        delay: 0.15 + i * 0.05,
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} style={{
        height: 6 + i * 3
      }} className={`w-[3px] origin-bottom rounded-full ${step === sentiment ? tone.fill : idle}`} data-id="element-416" data-mp="heu3wmn1dce4" data-mpi={i} />)}
      </div>
      <span className={`text-sm font-bold ${tone.text}`} data-id="element-417" data-mp="10bvdkkrjc0oe">
        {LABEL[sentiment]}
      </span>
    </div>;
}